
<ol class="breadcrumb">
  <ng-container *ngIf="breadcrumbs">
    <ng-container *ngFor="let breadcrumb of breadcrumbs">
      <li class="breadcrumb-item active" *ngIf="breadcrumb.mode === 'TEXT'">{{ breadcrumb.text }}</li>
      <li class="breadcrumb-item" *ngIf="breadcrumb.mode === 'HREF'"><a [attr.href]="breadcrumb.href">{{ breadcrumb.text }}</a></li>
      <li class="breadcrumb-item" *ngIf="breadcrumb.mode === 'ROUTER_LINK'"><a [routerLink]="breadcrumb.routerLink">{{ breadcrumb.text }}</a></li>
      <li class="breadcrumb-item" *ngIf="breadcrumb.mode === 'ROUTER_LINK_AND_PARAMS'"><a [routerLink]="breadcrumb.routerLink" [queryParams]="breadcrumb.queryParams">{{ breadcrumb.text }}</a></li>
    </ng-container>
  </ng-container>
</ol>